import { useState } from "react";
import { ArrowRight, Mail, Phone, Send } from "lucide-react";
import { ASSETS } from "@/data/magicalContent";
import { COMPANY } from "@/data/siteContact";

const initialForm = { name: "", phone: "", email: "", feedback: "" };

export function NewsletterFooter() {
  const [form, setForm] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const updateField = (field, value) => setForm((current) => ({ ...current, [field]: value }));
  const submitEnquiry = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/enquiries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!response.ok) throw new Error("Enquiry could not be saved");
      setSubmitted(true);
      setForm(initialForm);
    } catch {
      setError("We could not send your message just now. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <section id="newsletter" className="ns-newsletter" data-testid="newsletter-section">
        <div className="ns-envelope"><Mail size={42} /><i /></div>
        <div><p className="ns-kicker">A note from the stars</p><h2>Send a little<br /><em>magic our way.</em></h2><p>Share your name, contact details, and feedback. The Madneel Ventures team will get back to you soon.</p></div>
        <form className="ns-contact-form" data-testid="contact-enquiry-form" onSubmit={submitEnquiry}>
          <div className="ns-form-row"><input data-testid="contact-name-input" type="text" placeholder="Your name" value={form.name} onChange={(event) => updateField("name", event.target.value)} required /><input data-testid="contact-phone-input" type="tel" placeholder="Contact number" value={form.phone} onChange={(event) => updateField("phone", event.target.value)} required /></div>
          <input data-testid="newsletter-email-input" type="email" placeholder="your@email.com" value={form.email} onChange={(event) => updateField("email", event.target.value)} required />
          <textarea data-testid="contact-feedback-input" placeholder="Any feedback, questions, or magical ideas…" value={form.feedback} onChange={(event) => updateField("feedback", event.target.value)} rows="4" />
          {error && <p className="ns-form-error" data-testid="contact-form-error">{error}</p>}
          <button className="ns-button ns-button-primary" data-testid="newsletter-submit-button" disabled={submitting}>{submitting ? "Sending…" : submitted ? "Message sent" : "Send message"} <Send size={16} /></button>
          {submitted && <p className="ns-form-success" data-testid="contact-form-success">Thank you. Your message has been saved.</p>}
        </form>
      </section>
      <footer className="ns-footer">
        <a href="#home" data-testid="footer-brand-link"><img src={ASSETS.logo} alt="Niyati & Shivu logo" /><span>Niyati &amp; Shivu</span></a>
        <div className="ns-footer-company" data-testid="company-contact-info">
          <p>{COMPANY.credit}</p>
          <div><a href={COMPANY.phoneHref} data-testid="company-phone-link"><Phone size={13} /> {COMPANY.phone}</a><a href={COMPANY.emailHref} data-testid="company-email-link"><Mail size={13} /> {COMPANY.email}</a><a href={COMPANY.companyEmailHref} data-testid="company-secondary-email-link"><Mail size={13} /> {COMPANY.companyEmail}</a></div>
        </div>
        <p>Made with wonder, for every little dreamer.</p>
        <nav className="ns-footer-legal" data-testid="footer-legal-links" aria-label="Legal links"><a href="/privacy-policy" data-testid="footer-privacy-link">Privacy</a><a href="/terms" data-testid="footer-terms-link">Terms</a><a href="/shipping" data-testid="footer-shipping-link">Shipping</a><a href="/returns" data-testid="footer-returns-link">Returns</a></nav>
        <span>© 2026 Niyati &amp; Shivu</span>
      </footer>
    </>
  );
}
